import { useLayoutEffect, useRef } from "react";

/* Single-line-looking textarea that grows with its content (no inner scrolling, no horizontal scroll). 16px font so iOS doesn't zoom. */
export const AutoTextarea = ({ value, onChange, onEnter, className = "", onRef, ...rest }) => {
  const ref = useRef(null);
  useLayoutEffect(() => { const el = ref.current; if (!el) return; el.style.height = "0px"; el.style.height = `${el.scrollHeight + el.offsetHeight - el.clientHeight}px`; }, [value]);
  return (
    <textarea ref={(el) => { ref.current = el; onRef?.(el); }} rows={1} value={value} onChange={onChange} className={`field field-auto ${className}`}
      onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey && onEnter) { e.preventDefault(); onEnter(e); } }} {...rest} />
  );
};
